import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="M24.925 9.3A1.838 1.838 0 0 1 22.7 7.075c.132-.537.169-1.177-.222-1.568l-1.893-1.893a1.839 1.839 0 0 0-2.6 0l-14.37 14.37a1.839 1.839 0 0 0 0 2.6l1.893 1.894c.39.39 1.03.353 1.567.222A1.838 1.838 0 0 1 9.3 24.925c-.131.536-.169 1.177.222 1.567l1.893 1.893a1.839 1.839 0 0 0 2.6 0l14.37-14.37a1.839 1.839 0 0 0 0-2.6l-1.892-1.893c-.39-.39-1.031-.354-1.568-.222zm-6.916 4.144c.22-.07.389-.047.487.051.098.099.121.268.046.482l-.604 1.86 1.07 1.549c.257.378.094.705-.368.725l-1.92.08-1.212 1.567c-.205.266-.444.306-.614.136a.675.675 0 0 1-.153-.271l-.584-1.788-1.778-.574a.675.675 0 0 1-.271-.153c-.17-.17-.13-.409.136-.614l1.568-1.211.08-1.92c.016-.467.342-.63.724-.369l1.538 1.06 1.855-.61z" clip-rule="evenodd" stroke="none"></path>';
export var TicketSVG = function TicketSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
TicketSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TicketSVG);